// Small status pill rendered next to each
// Underwriting tab section title.

import { Badge } from "@/design-system/components/ui";

export type SectionStatus = "Open" | "InProgress" | "Complete" | "Locked";

const STATUS_LABEL: Record<SectionStatus, string> = {
  Open: "Open",
  InProgress: "In Progress",
  Complete: "Complete",
  Locked: "Locked",
};

const STATUS_BADGE: Record<SectionStatus, "draft" | "review" | "finalized" | "archived"> = {
  Open: "draft",
  InProgress: "review",
  Complete: "finalized",
  Locked: "archived",
};

export function SectionStatusBadge({ status }: { status: SectionStatus }) {
  return <Badge status={STATUS_BADGE[status]}>{STATUS_LABEL[status]}</Badge>;
}
